import { Stack, Typography, useTheme } from '@mui/material';
import { t } from 'i18next';

import CustomDialog, { CustomDialogProps } from './customDialog';

interface ConfirmationDialogProps extends CustomDialogProps {
	/**
	 * A helper text to provide more information about
	 * the action.
	 */
	helperText?: string;
	enableWriteConfirmation?: boolean;
	writeConfirmationValue?: string;
}

const ConfirmationDialog = ({
	title = t('areYouSure', { ns: 'actions' }),
	loading = false,
	confirmButtonText: confirmText = t('confirm', { ns: 'actions' }),
	abortButtonText: abortText = t('cancel', { ns: 'actions' }),
	onConfirm,
	onClose,
	helperText,
	slots,
	icon,
	...dialogProps
}: ConfirmationDialogProps) => {
	const theme = useTheme();

	const handleConfirmClick = () => {
		onConfirm?.();
	};

	const handleDeclineClick = () => {
		onClose?.();
	};

	return (
		<CustomDialog
			{...dialogProps}
			title={title}
			onClose={handleDeclineClick}
			onDecline={handleDeclineClick}
			onConfirm={handleConfirmClick}
			loading={loading}
			confirmButtonText={confirmText}
			abortButtonText={abortText}
			icon={icon}
		>
			<Stack
				spacing={1}
				sx={{
					alignItems: 'center',
				}}
			>
				{!helperText ? null : (
					<Stack spacing={1} sx={{ width: '440px' }} alignItems='center'>
						<Typography
							variant='paragraphSm'
							color={theme.palette.textTertiary.main}
							sx={{ textAlign: 'center', maxWidth: '280px' }}
						>
							{helperText}
						</Typography>
					</Stack>
				)}
			</Stack>
		</CustomDialog>
	);
};

export default ConfirmationDialog;
